module.exports = __webpack_public_path__ + "assets/images/project/menu/philippines-thumb.jpg?v=77aad836";